import React from 'react'
import { Collection } from '@morningtrain/react-resources'
import { SearchFilter } from '@morningtrain/react-filters'
import { EmployeeCategoryFilter, SelectedDepartmentFilter } from 'support/filters'
import TabletChecklist from 'pages/app/checklists/TabletChecklist'
import WhenDeviceNotAuthorized from 'support/conditionals/WhenDeviceNotAuthorized'
import ChecklistListView from './ChecklistListView'
import WhenIndexingChecklist from './WhenIndexingChecklist'
import AdminPageWithStickySmartview from '../AdminPageWithStickySmartview'
import * as UI from 'ui'
import { Translation, Translator } from '@morningtrain/react-translations'
import WhenViewingChecklistInstance from 'pages/app/checklists/WhenViewingChecklistInstance'
import ChecklistInstance from 'pages/app/checklists/ChecklistInstance'
import moment from 'moment'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'
import DateFilterSyncedWithEnv from 'support/filters/DateFilterSyncedWithEnv'
import { Link, OnNavigatePipeline } from '@morningtrain/react-navigation'
import { MountSmartviewOnPipe } from '@morningtrain/react-smartviews'
import { ChecklistSmartview } from 'widgets/smartviews/checklists/ChecklistSmartview'

export default function Checklists () {
  const defaultPeriod = moment().endOf('day').toDate()

  return (
    <>
      <WhenDeviceNotAuthorized>
        <AdminPageWithStickySmartview>
          <Can permission={Permissions.CHECKLIST_TEMPLATES_MANAGE}>
            <OnNavigatePipeline>
              <MountSmartviewOnPipe smartview={<ChecklistSmartview />} replace />
            </OnNavigatePipeline>
          </Can>
          <Translator namespace='checklists'>

            <UI.CardGroup>
              <Can permission={Permissions.CHECKLISTS_MANAGE}>
                <UI.PageHeader title={<Translation name='checklist_history' />}>
                  <UI.ButtonWrap>
                    <Can permission={Permissions.CHECKLIST_TEMPLATES_MANAGE}>
                      <Link route='app.checklist_templates'>
                        <UI.Button>
                          <UI.WithIcon size={5} placement='right' icon={<UI.Icons.Settings />}>
                            <Translation name='actions.manage_templates' />
                          </UI.WithIcon>
                        </UI.Button>
                      </Link>
                    </Can>
                  </UI.ButtonWrap>
                </UI.PageHeader>
                <Collection resourceName='checklists.checklists'>
                  <SelectedDepartmentFilter />
                  <UI.TableHeader>
                    <SearchFilter label={false} />
                    <DateFilterSyncedWithEnv
                      name='date'
                      label={false}
                      envName='checklist.filter.period'
                      defaultDate={defaultPeriod}
                    />
                    <EmployeeCategoryFilter defaultValue={null} allowNull />
                  </UI.TableHeader>

                  <WhenIndexingChecklist>
                    <ChecklistListView />
                  </WhenIndexingChecklist>

                  <WhenViewingChecklistInstance>
                    <ChecklistInstance />
                  </WhenViewingChecklistInstance>
                </Collection>
              </Can>
            </UI.CardGroup>
          </Translator>
        </AdminPageWithStickySmartview>
      </WhenDeviceNotAuthorized>
      <TabletChecklist />
    </>

  )
}
